export const SET_SHIPMENTS_GROUPBYDAY_LIST = 'SET_SHIPMENTS_GROUPBYDAY_LIST'
export const SET_SHIPMENTS_GROUPBYDAY_IS_FETCHING = 'SET_SHIPMENTS_GROUPBYDAY_IS_FETCHING'
export const UPDATE_SHIPMENTS_GROUPBYDAY_LIST = 'UPDATE_SHIPMENTS_GROUPBYDAY_LIST'
export const UPDATE_SELECTED_SHIPMENT_CARD = 'UPDATE_SELECTED_SHIPMENT_CARD'

export const SET_TOGGLE_SHIPMENT = 'SET_TOGGLE_SHIPMENT'
export const REMOVE_TOGGLE_SHIPMENT = 'REMOVE_TOGGLE_SHIPMENT'

export const SET_TOGGLE_DAY = 'SET_TOGGLE_DAY'
export const REMOVE_TOGGLE_DAY = 'REMOVE_TOGGLE_DAY'

export const SET_SHIPMENTS_GROUPBYDAY_ERRORS = 'SET_SHIPMENTS_GROUPBYDAY_ERRORS'
export const REMOVE_SHIPMENTS_GROUPBYDAY_ERRORS = 'REMOVE_SHIPMENTS_GROUPBYDAY_ERRORS'

export const SET_SHIPMENTS_GROUPBYDAY_LAST_DAY = 'SET_SHIPMENTS_GROUPBYDAY_LAST_DAY'
export const SET_SHIPMENTS_GROUPBYDAY_TOTAL = 'SET_TOTAL'
export const SET_SHIPMENTS_GROUPBYDAY_RANGES = 'SET_SHIPMENTS_GROUPBYDAY_RANGES'

export const SET_SELECTED_VIEW = 'SET_SELECTED_VIEW'
export const SET_LAST_URL = 'SET_LAST_URL'

export const UPDATE_SELECTED_SHIPMENT_CARD_LABELS = 'UPDATE_SELECTED_SHIPMENT_CARD_LABELS'

export const SET_EXCHANGE_RATES = 'SET_EXCHANGE_RATES'

export const SET_RESET_STATE = 'SET_RESET_STATE'
